module.exports = __webpack_public_path__ + "img/zc-05.29e7e8d5.svg";